import i18n from 'i18next';

import type {
  TFacesColumns,
  TEventsColumns,
  TObjectType,
  TColumnsObj,
} from '../types';

export const columnsArrayToKeyMap = (
  colArr: TFacesColumns[] | TEventsColumns[],
  type: TObjectType,
): TColumnsObj => {
  const columnsObj: TColumnsObj = {};
  if (type === 'faces') {
    colArr.forEach((key) => {
      columnsObj[key] = i18n.t(`features:exportTask.form.checkboxGroup.faces.${key}`) as unknown as string;
    });
  } else if (type === 'events') {
    colArr.forEach((key) => {
      columnsObj[key] = i18n.t(`features:exportTask.form.checkboxGroup.events.${key}`) as unknown as string;
    });
  }

  return columnsObj;
};
